import React, { useState } from 'react';
import Accordion from '@src/components/reusable/Accordion';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { directLinkStateSelector } from '@src/stores/directLink';
import Hidden from '@src/components/ui2/Hidden';
import PaymentStep from '../Checkout/PaymentStep';
import SummaryDrawer from '../Checkout/SummaryDrawer';
import { Container, Steps, Step, StepNumber, StepContainer, Summary as SummaryStep } from './styles';
import Summary from '../Checkout/Summary';

type PaymentProps = {
  onSuccess?: () => void;
};

const Payment = (props: PaymentProps) => {
  const { onSuccess = () => {} } = props;

  const { i18n } = useTranslate();

  const { directLink } = useAppSelector(directLinkStateSelector);

  const [paymentOpen, setPaymentOpen] = useState<boolean>(true);
  const [summaryOpen, setSummaryOpen] = useState<boolean>(true);

  return (
    <div>
      <Container>
        <Steps>
          <Step>
            <Accordion
              open={paymentOpen}
              onClick={() => setPaymentOpen(!paymentOpen)}
              titleIcon={() => <StepNumber>1</StepNumber>}
              title={i18n('direct_link_payment_step_title')}
            >
              <StepContainer>
                <PaymentStep directLink={directLink} onSuccess={onSuccess} />
              </StepContainer>
            </Accordion>
          </Step>
        </Steps>

        <SummaryStep>
          <Accordion
            open={summaryOpen}
            onClick={() => setSummaryOpen(!summaryOpen)}
            titleIcon={() => null}
            title={i18n('direct_link_summary_title_payment')}
          >
            <StepContainer>
              <Summary directLink={directLink!} showTotal />
            </StepContainer>
          </Accordion>
        </SummaryStep>

        <Hidden smUp>
          <SummaryDrawer open={summaryOpen} onToggle={() => setSummaryOpen(!summaryOpen)} />
        </Hidden>
      </Container>
    </div>
  );
};

export default Payment;
